import { ReactNode } from 'react';
import { cn } from '@/lib/utils';

export type BadgeVariant = 'blue' | 'green' | 'yellow' | 'red' | 'gray' | 'purple';

interface BadgeProps {
  variant?: BadgeVariant;
  children: ReactNode;
  className?: string;
}

const variantClasses: Record<BadgeVariant, string> = {
  blue: 'bg-blue-500/20 text-blue-400 border-blue-500/30',
  green: 'bg-green-500/20 text-green-400 border-green-500/30',
  yellow: 'bg-yellow-500/20 text-yellow-400 border-yellow-500/30',
  red: 'bg-red-500/20 text-red-400 border-red-500/30',
  gray: 'bg-gray-500/20 text-gray-400 border-gray-500/30',
  purple: 'bg-purple-500/20 text-purple-400 border-purple-500/30',
};

export function Badge({ variant = 'gray', children, className }: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border',
        variantClasses[variant],
        className
      )}
    >
      {children}
    </span>
  );
}

// Helper function to get badge variant based on role
export function getRoleBadgeVariant(role: string): BadgeVariant {
  switch (role) {
    case 'parent':
      return 'purple';
    case 'caretaker':
      return 'blue';
    case 'admin':
      return 'yellow';
    case 'family':
      return 'yellow';
    case 'professional':
      return 'green';
    default:
      return 'gray';
  }
}

// Helper function to get badge variant based on time slot status
export function getStatusBadgeVariant(status: string): BadgeVariant {
  switch (status) {
    case 'available':
      return 'green';
    case 'claimed':
      return 'yellow';
    case 'confirmed':
      return 'blue';
    case 'completed':
      return 'gray';
    case 'cancelled':
      return 'red';
    default:
      return 'gray';
  }
}

export default Badge;
